import {H2, H3, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {withBgGreen50} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';
import {DivMargined, FeatureItem, Grid, workableAgentLink} from '@/content/features/shared';

const imgPath = '/static/images/features/candidate-sourcing/';

const Green50Section = withBgGreen50(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3Upper = withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)));

const CandidateSourcingSection = () => {
  const t = useTranslations('features.candidateSourcing');

  const JobPostingsFeaturesArray = t.raw('jobPosting.features') as FeatureItem[];
  const CandidateSourcingFeaturesArray = t.raw('candidateSourcing.features') as FeatureItem[];
  const RecruitmentMarketingFeaturesArray = t.raw('recruitmentMarketing.features') as FeatureItem[];

  return (
    <Green50Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="candidate-sourcing-suite"
                imageTypeFallback="jpg"
                altImage={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('jobPosting.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {JobPostingsFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--green100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('candidateSourcing.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CandidateSourcingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--green100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>
                      {item.richCopy
                        ? t.rich(`candidateSourcing.${item.richCopy}`, {link: workableAgentLink})
                        : item.copy}
                    </PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('recruitmentMarketing.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {RecruitmentMarketingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--green100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Green50Section>
  );
};

export default CandidateSourcingSection;
